var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path23, _path24, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M81.7311 50.0007C81.7311 32.4763 67.5247 18.2699 50.0003 18.2699C32.4759 18.2699 18.2695 32.4763 18.2695 50.0007C18.2695 67.5251 32.4759 81.7314 50.0003 81.7314C67.5247 81.7314 81.7311 67.5251 81.7311 50.0007Z",
    fill: "#D6F0D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1928_19929)",
    filter: "url(#filter0_ddd_1928_19929)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8848 71.8848C62.035 71.8848 71.8848 62.035 71.8848 49.8848C71.8848 37.7345 62.035 27.8848 49.8848 27.8848C37.7345 27.8848 27.8848 37.7345 27.8848 49.8848C27.8848 62.035 37.7345 71.8848 49.8848 71.8848Z",
    fill: "#0AC20A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7856 50.7111L46.7856 55.6871L58.2142 44.3135",
    stroke: "white",
    strokeWidth: 3
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9351 2.32539C62.0359 1.86669 62.4992 1.58499 62.9528 1.70657C63.4065 1.82815 63.6669 2.30381 63.5249 2.75147L60.0448 13.7228C59.9962 13.876 59.8357 13.9639 59.6804 13.9223C59.5251 13.8807 59.43 13.7243 59.4645 13.5673L61.9351 2.32539Z",
    fill: "#D6F0D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0879 97.701C37.9871 98.1597 37.5238 98.4414 37.0701 98.3198C36.6165 98.1982 36.3561 97.7226 36.4981 97.2749L39.9781 86.3036C40.0267 86.1503 40.1873 86.0624 40.3426 86.1041C40.4979 86.1457 40.593 86.3021 40.5584 86.4591L38.0879 97.701Z",
    fill: "#D6F0D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4246 0.592188C47.4044 0.271357 47.6591 0 47.9806 0C48.3002 0 48.5542 0.268316 48.5368 0.587425L48.3033 4.86185C48.2944 5.02348 48.1608 5.15001 47.9989 5.15001C47.8381 5.15001 47.7049 5.02499 47.6948 4.86445L47.4246 0.592188Z",
    fill: "#D6F0D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4246 99.4078C47.4044 99.7286 47.6591 100 47.9806 100C48.3002 100 48.5542 99.7317 48.5368 99.4126L48.3033 95.1382C48.2944 94.9765 48.1608 94.85 47.9989 94.85C47.8381 94.85 47.7049 94.975 47.6948 95.1355L47.4246 99.4078Z",
    fill: "#D6F0D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1063 18.9601C88.4618 18.653 89.0015 18.7049 89.292 19.074C89.5825 19.4431 89.5061 19.9801 89.1243 20.2536L79.7685 26.9548C79.6377 27.0485 79.4565 27.0227 79.3571 26.8963C79.2576 26.77 79.2751 26.5877 79.3968 26.4826L88.1063 18.9601Z",
    fill: "#D6F0D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.902 81.0546C11.5465 81.3616 11.0068 81.3097 10.7163 80.9406C10.4258 80.5715 10.5022 80.0345 10.884 79.761L20.2398 73.0598C20.3706 72.9662 20.5518 72.992 20.6512 73.1183C20.7507 73.2447 20.7332 73.4269 20.6115 73.532L11.902 81.0546Z",
    fill: "#D6F0D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5225 8.88347C77.6984 8.61435 78.0649 8.5496 78.3224 8.74217C78.5783 8.93362 78.6211 9.30072 78.416 9.54587L75.6697 12.8289C75.5659 12.9531 75.3831 12.9744 75.2534 12.8774C75.1246 12.7811 75.0928 12.6012 75.1809 12.4665L77.5225 8.88347Z",
    fill: "#D6F0D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5225 8.88347C77.6984 8.61435 78.0649 8.5496 78.3224 8.74217C78.5783 8.93362 78.6211 9.30072 78.416 9.54587L75.6697 12.8289C75.5659 12.9531 75.3831 12.9744 75.2534 12.8774C75.1246 12.7811 75.0928 12.6012 75.1809 12.4665L77.5225 8.88347Z",
    fill: "#D6F0D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3563 88.0169C18.1479 88.2617 18.1894 88.6316 18.4469 88.8242C18.7028 89.0156 19.0669 88.9529 19.2441 88.6869L21.6163 85.1241C21.7061 84.9893 21.6748 84.8079 21.5452 84.711C21.4164 84.6146 21.2349 84.635 21.1306 84.7575L18.3563 88.0169Z",
    fill: "#D6F0D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1386 49.1788C99.6079 49.1575 100 49.5322 100 50.0019C100 50.4717 99.6079 50.8464 99.1386 50.825L87.6435 50.3024C87.4828 50.2951 87.3563 50.1627 87.3563 50.0019C87.3563 49.8411 87.4828 49.7087 87.6435 49.7014L99.1386 49.1788Z",
    fill: "#D6F0D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.861382 50.8251C0.392117 50.8464 -1.39716e-08 50.4717 -3.0692e-08 50.002C-4.74124e-08 49.5322 0.392118 49.1575 0.861382 49.1789L12.3565 49.7015C12.5172 49.7088 12.6437 49.8412 12.6437 50.002C12.6437 50.1628 12.5172 50.2952 12.3565 50.3025L0.861382 50.8251Z",
    fill: "#D6F0D9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0552 34.7149C97.36 34.6122 97.688 34.7881 97.7713 35.0987C97.854 35.4074 97.6605 35.7224 97.3477 35.7882L93.1598 36.6688C93.0014 36.7021 92.8445 36.6057 92.8027 36.4493C92.761 36.2939 92.8473 36.1329 92.9998 36.0815L97.0552 34.7149Z",
    fill: "#B6DDBB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.62919 60.2911C1.31397 60.3545 1.11774 60.6709 1.20094 60.9815C1.28365 61.2903 1.60863 61.4662 1.91242 61.3668L5.97941 60.035C6.13328 59.9846 6.22094 59.8227 6.17904 59.6663C6.13741 59.5109 5.98217 59.4146 5.82444 59.4464L1.62919 60.2911Z",
    fill: "#B6DDBB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2025 79.6415C89.5851 79.9139 89.6629 80.4507 89.3734 80.8206C89.0839 81.1905 88.5443 81.2438 88.188 80.9378L79.4582 73.4389C79.3362 73.3341 79.3182 73.1519 79.4173 73.0253C79.5164 72.8987 79.6975 72.8724 79.8285 72.9657L89.2025 79.6415Z",
    fill: "#B6DDBB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7995 20.3468C10.4169 20.0744 10.3391 19.5376 10.6285 19.1677C10.918 18.7978 11.4576 18.7445 11.8139 19.0505L20.5438 26.5494C20.6658 26.6542 20.6838 26.8363 20.5847 26.963C20.4856 27.0896 20.3044 27.1159 20.1735 27.0226L10.7995 20.3468Z",
    fill: "#B6DDBB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4755 66.9675C96.7787 67.0745 96.9287 67.4153 96.8028 67.7112C96.6777 68.0053 96.3312 68.134 96.0444 67.9929L92.204 66.1044C92.0587 66.0329 91.9946 65.8604 92.058 65.7114C92.121 65.5634 92.2882 65.4898 92.4399 65.5433L96.4755 66.9675Z",
    fill: "#B6DDBB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5728 28.2713C5.28549 28.127 4.93601 28.2551 4.81013 28.551C4.68498 28.8451 4.83243 29.1841 5.13293 29.293L9.15619 30.7518C9.3084 30.807 9.47717 30.7335 9.54056 30.5846C9.60355 30.4365 9.54065 30.265 9.39688 30.1927L5.5728 28.2713Z",
    fill: "#B6DDBB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M67.71 95.8476C67.8917 96.2807 67.6751 96.7778 67.2342 96.9397C66.7933 97.1016 66.3066 96.8627 66.165 96.4149L62.6943 85.4406C62.6458 85.2873 62.7265 85.123 62.8774 85.0676C63.0283 85.0122 63.1961 85.0853 63.2583 85.2335L67.71 95.8476Z",
    fill: "#B6DDBB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2997 4.13386C32.1181 3.70076 32.3347 3.20361 32.7756 3.04174C33.2165 2.87987 33.7032 3.11879 33.8448 3.56659L37.3155 14.5408C37.364 14.6941 37.2833 14.8585 37.1324 14.9139C36.9815 14.9693 36.8137 14.8962 36.7515 14.7479L32.2997 4.13386Z",
    fill: "#B6DDBB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5698 88.9045C80.7711 89.1552 80.7191 89.5238 80.4563 89.7089C80.195 89.893 79.8328 89.8199 79.6633 89.5489L77.3936 85.9199C77.3078 85.7826 77.3442 85.6022 77.4765 85.509C77.6081 85.4163 77.7889 85.4418 77.8896 85.5673L80.5698 88.9045Z",
    fill: "#B6DDBB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6844 8.11518C23.5162 7.84115 23.1517 7.76597 22.8889 7.95112C22.6276 8.13519 22.5744 8.50092 22.7724 8.75181L25.4239 12.1119C25.5241 12.239 25.7063 12.2655 25.8386 12.1723C25.9701 12.0796 26.007 11.9007 25.9229 11.7636L23.6844 8.11518Z",
    fill: "#B6DDBB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.5,
    cy: 5.91569,
    rx: 0.766096,
    ry: 0.766277,
    fill: "#22A32F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.78074,
    cy: 68.4606,
    rx: 0.766096,
    ry: 0.766277,
    fill: "#22A32F"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.8354,
    cy: 57.1022,
    rx: 0.766096,
    ry: 0.766277,
    fill: "#22A32F"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.2241,
    cy: 86.8356,
    rx: 0.766096,
    ry: 0.766277,
    fill: "#22A32F"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.603,
    cy: 15.2116,
    rx: 0.766096,
    ry: 0.766277,
    fill: "#22A32F"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.7422,
    cy: 80.8561,
    rx: 0.766096,
    ry: 0.766277,
    fill: "#22A32F"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.94676,
    cy: 39.4567,
    rx: 0.766096,
    ry: 0.766277,
    fill: "#22A32F"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.3564,
    cy: 31.1452,
    rx: 0.766096,
    ry: 0.766277,
    fill: "#22A32F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.958 16.6455L23.5058 17.4893L24.4775 17.2289L23.8444 18.0108L24.3923 18.8547L23.4532 18.4941L22.8201 19.276L22.8728 18.2712L21.9337 17.9107L22.9053 17.6503L22.958 16.6455Z",
    fill: "#22A32F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1268 89.6758L56.9176 90.66L57.7888 91.1631L56.7884 91.2683L56.5792 92.2524L56.1701 91.3333L55.1697 91.4384L55.9172 90.7652L55.5081 89.846L56.3792 90.3491L57.1268 89.6758Z",
    fill: "#22A32F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_1928_19929",
    x: 19.8848,
    y: 23.8848,
    width: 60.231,
    height: 60.2305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.211765 0 0 0 0 0.219608 0 0 0 0 0.298039 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1928_19929"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.211765 0 0 0 0 0.219608 0 0 0 0 0.298039 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1928_19929",
    result: "effect2_dropShadow_1928_19929"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.211765 0 0 0 0 0.219608 0 0 0 0 0.298039 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1928_19929",
    result: "effect3_dropShadow_1928_19929"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1928_19929",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1928_19929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.2308,
    height: 44.2308,
    fill: "white",
    transform: "translate(27.8848 27.8848)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/RightIcon.bd521146630d39a05f188276428d6d5c.svg";
export { ForwardRef as ReactComponent };